import { type MeterTableState } from './meter-table-types'

import {
  CloseRemoveMeterDialogAction,
  OpenRemoveMeterDialogAction,
  SetCompanyAlarmAction,
  SetCompanyAlarmDialogVisibilityAction,
  SetMeterActivePageAction,
  SetMeterPageSizeAction,
  ToggleDownloadDialogAction,
  ToggleMeterSettingsDialogAction,
  ToggleRemoveMeterConfirmedAction
} from './meter-table-actions'
import { createReducer } from '@reduxjs/toolkit'
import {
  DeleteMeterSuccessAction,
  FetchMetersAction,
  FetchMetersFailureAction,
  FetchMetersSuccessAction,
  UpdateMeterSuccessAction
} from '../meters/meter-actions'

export const initialMeterTableState: MeterTableState = {
  companyAlarm: { companyId: null, alarmType: null, state: false, maxFlowPerHour: null },
  downloadDialogOpen: false,
  isSetCompanyAlarmDialogOpen: false,
  loading: 0,
  meterActivePage: 1,
  meterPageSize: 10,
  meterSaving: false,
  meterSettingsDialogOpen: false,
  removeMeterConfirmed: false,
  removeMeterDialogOpen: false
}

export const meterTableReducer = createReducer(initialMeterTableState, builder => {
  builder.addCase(ToggleDownloadDialogAction, (state, _action) => {
    state.downloadDialogOpen = !state.downloadDialogOpen
  }).addCase(SetMeterActivePageAction, (state, action) => {
    state.meterActivePage = action.payload.activePage
  }).addCase(SetMeterPageSizeAction, (state, action) => {
    state.meterPageSize = action.payload.pageSize
    state.meterActivePage = 1
  }).addCase(DeleteMeterSuccessAction, (state, _action) => {
    state.removeMeterConfirmed = false
    state.removeMeterDialogOpen = false
    state.meterSettingsDialogOpen = false
  }).addCase(ToggleRemoveMeterConfirmedAction, (state, _action) => {
    state.removeMeterConfirmed = !state.removeMeterConfirmed
  }).addCase(ToggleMeterSettingsDialogAction, (state, _action) => {
    state.meterSettingsDialogOpen = !state.meterSettingsDialogOpen
  }).addCase(OpenRemoveMeterDialogAction, (state, _action) => {
    state.removeMeterConfirmed = false
    state.removeMeterDialogOpen = true
  }).addCase(CloseRemoveMeterDialogAction, (state, _action) => {
    state.removeMeterConfirmed = false
    state.removeMeterDialogOpen = false
  }).addCase(UpdateMeterSuccessAction, (state, _action) => {
    state.meterSettingsDialogOpen = false
    state.meterSaving = false
  }).addCase(SetCompanyAlarmDialogVisibilityAction, (state, action) => {
    state.isSetCompanyAlarmDialogOpen = action.payload
  }).addCase(SetCompanyAlarmAction, (state, action) => {
    state.companyAlarm = action.payload
  }).addCase(FetchMetersAction, (state, _action) => {
    state.loading += 1
  }).addCase(FetchMetersSuccessAction, (state, _action) => {
    state.loading -= 1
  }).addCase(FetchMetersFailureAction, (state, _action) => {
    state.loading -= 1
  })
})
